/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Script_Name_Placeholder_SstInputs */



/**
* | output |
* | --- |
* | "untitled.sst" |
*
* @param {Image_Export_Script_Name_Placeholder_SstInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_script_name_placeholder_sst = /** @type {((inputs?: Image_Export_Script_Name_Placeholder_SstInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Script_Name_Placeholder_SstInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("untitled.sst")
	if (locale === "de") return /** @type {LocalizedString} */ ("untitled.sst")
	if (locale === "it") return /** @type {LocalizedString} */ ("untitled.sst")
	if (locale === "ru") return /** @type {LocalizedString} */ ("untitled.sst")
	if (locale === "es") return /** @type {LocalizedString} */ ("untitled.sst")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("untitled.sst")
	if (locale === "ja") return /** @type {LocalizedString} */ ("untitled.sst")
	if (locale === "hi") return /** @type {LocalizedString} */ ("untitled.sst")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("untitled.sst")
	return /** @type {LocalizedString} */ ("untitled.sst")
});